/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".pad0[_ngcontent-%COMP%]{padding:0}textarea[_ngcontent-%COMP%]:focus{border-color:#1f628e!important}.supCls[_ngcontent-%COMP%]{border:1px solid #ddd!important}.supCls[_ngcontent-%COMP%]:focus{border:1px solid #1f628e!important}"];
export { styles as styles };

